var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    viewBox: "0 0 509.336 509.336",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m105 23.57h30v92.195h-30z",
    transform: "matrix(.759 -.651 .651 .759 -16.45 94.867)",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.902 54.668h92.195v30h-92.195z",
    transform: "matrix(.651 -.759 .759 .651 72.819 297.661)",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.5 14.668h30v90h-30z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.091 234.232c-16.053-15.025-39.639-17.106-57.812-6.055 5.735-18.779 8.721-38.468 8.721-58.51v-15h-415v15c0 50.617 19.385 99.462 53.654 136.306l-83.654 65.195v38.034l119.306-92.978.09-.07c13.428-10.631 30.255-16.485 47.382-16.485h93.594c17.525 0 32.052 13.085 34.32 30h-89.692v30h125.643l118.587-103.932c7.048-6.176 17.518-6.005 24.36.398 3.734 3.496 5.775 8.238 5.745 13.354-.029 5.115-2.125 9.834-5.9 13.286l-144.258 131.893h-204.69l-94.117 80h46.32l58.824-50h205.31l152.854-139.752c9.872-9.026 15.579-21.876 15.657-35.252.078-13.377-5.479-26.291-15.244-35.432zm-79.748-49.564c-.896 10.197-2.708 20.232-5.383 30h-342.855c-2.693-9.777-4.528-19.815-5.437-30zm-89.971 140.604c-4.404-31.379-31.427-55.604-64.001-55.604h-93.594c-21.028 0-41.725 6.343-59.148 17.985-12.284-12.757-22.426-27.286-30.142-42.985h320.108c-7.076 14.384-16.219 27.814-27.268 39.862l.26.238z",
    fill: "currentColor",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe);
export default __webpack_public_path__ + "static/media/serve.69b05974f169c9037c8e234af19f1069.svg";
export { ForwardRef as ReactComponent };